import feedback_user_1 from '../../assets/images/feedback/user-1.svg';
import feedback_user_2 from '../../assets/images/feedback/user-2.svg';
import feedback_user_3 from '../../assets/images/feedback/user-3.svg';
const blog = [
    {
        thumbnail: feedback_user_1,
        title: 'Phillipe Bourbon',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: '¡Más del 90% de nuestros HR Specialist, encontraron excelentes candidatos en menos de 2 semanas con procesos más cortos! Sin duda ahorro de tiempo y dinero. ',
        subtitle: 'HR Manager',
        url : ""
    },
    {
        thumbnail: feedback_user_2,
        title: 'Letizia Tocamadera',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: '¡El proceso anónimo ha sido esencial para poder acceder a este trabajo. Me han dado la oportunidad que hasta ahora no había conseguido!',
        subtitle: 'Graphic Designer',
        url : ""
    },
    {
        thumbnail: feedback_user_3,
        title: 'Jaime Glosling',
        commentCount: 12,
        date: 'Dec 10, 2020',
        excerpt: '¡Finalmente un proceso sencillo, profesional, rápido y efectivo. Sin tanta floritura, ni preguntas chorras o pruebas inútiles. Todo ha sido súper pro!',
        subtitle: 'Backend Senior',
           url : ""
    }
]

export default blog;